// Copyright (c) 2023 WiseTime. All rights reserved.

import React, { useEffect, useMemo } from "react"
import { useDispatch, useSelector } from "react-redux"
import { RootState } from "../../../app/store"
import { TagCategoryRef } from "../../../generated/wisetime/user/type/tag_category_ref_pb"
import { selectTagColor } from "../slices/timeline"
import * as TimelineAdditionalUiSlice from "../slices/additionalUi"
import * as TagsSlice from "../../tags/slice"
import * as TagsActions from "../../tags/actions"
import { GetTagCategoryRequest } from "../../../generated/legebill/site/tag/v4/tag_pb"
import styled from "styled-components/macro"
import { getTagCategoryDescription } from "../../tags/tags"
import { DropdownHeader, DropdownHeaderTitle, renderLabel } from "./TagCategoriesDropdown"

const Wrapper = styled(DropdownHeader)`
  display: inline-block;
  vertical-align: top;
  margin: 4px 4px 0 0;
`

type Props = {
  tagCategoryRef: TagCategoryRef.AsObject,
}

const TagCategoryLabel = ({ tagCategoryRef }: Props) => {
  const dispatch = useDispatch()
  const selectColor = useMemo(selectTagColor, [])
  const tagCategoryColor = useSelector((state: RootState) => selectColor(state, tagCategoryRef.id))
  const tagsViewType = useSelector(TimelineAdditionalUiSlice.selectTagsViewType)

  const makeSelectTagCategoryById = useMemo(TagsSlice.selectTagCategoryById, [])
  const tagCategory = useSelector((state: RootState) => makeSelectTagCategoryById(state, tagCategoryRef.id))

  useEffect(() => {
    if (tagCategory === undefined) {
      // If the full tag category hasn't been cached, fetch and cache it now
      dispatch(TagsActions.getTagCategory(new GetTagCategoryRequest().setTagCategoryId(tagCategoryRef.id)))
    }
  }, [tagCategoryRef])

  return (
    <Wrapper tagCategoryColor={tagCategoryColor}>
      <DropdownHeaderTitle
        title={tagCategory ? `${tagCategory.label}\n${getTagCategoryDescription(tagCategory)}`
          : tagCategoryRef.label}
      >
        {tagCategory ? renderLabel(tagsViewType, tagCategory) : tagCategoryRef.label}
      </DropdownHeaderTitle>
    </Wrapper>
  )
}

export default TagCategoryLabel
